function magneticEffect(time, diff, shots){
    for (const shot of shots){
        if(Math.abs(time - shot) < diff){
            return shot
        }
    }
    return -1;
}

export function moveTrimPoint(
    trimPoints,
    seek,
    totalVideoTime,
    index,
    type,
    deleteTrimPoint,
    updateTrimPoints,
    mergeTrimPoints,
    magnetic
){
    const prevEndGrabber = index - 1 >= 0 ? trimPoints[index - 1] : null
    const nextStartGrabber = index + 1 < trimPoints.length ? trimPoints[index + 1] : null
    const isStartGrabber = type === 'start';
    const beforeStart = seek < 0;
    const afterEnd = seek > totalVideoTime;
    const beforePrevEnd = prevEndGrabber ? seek <= prevEndGrabber.end : false;
    const afterNextStart = nextStartGrabber ? seek >= nextStartGrabber.start : false;
    const beforeCurrentStart = seek <= trimPoints[index].start;
    const afterCurrentEnd = seek >= trimPoints[index].end;
    const magneticValue = magneticEffect(seek, 10, magnetic.shots)
    const useMagnetic = magnetic.use && magneticValue >= 0
    /*console.log({
        index: index,
        isStartGrabber: type === 'start',
        beforeStart: seek < 0,
        afterEnd: seek > totalVideoTime,
        beforePrevEnd: prevEndGrabber ? seek <= prevEndGrabber.end : false,
        afterNextStart: nextStartGrabber ? seek >= nextStartGrabber.start : false,
        beforeCurrentStart: seek <= trimPoints[index].start,
        afterCurrentEnd: seek >= trimPoints[index].end
    });*/
    if (isStartGrabber && afterCurrentEnd) {
        deleteTrimPoint(index)
    } else if(isStartGrabber && beforePrevEnd){
        mergeTrimPoints(index - 1, index)
    } else if (isStartGrabber && !afterCurrentEnd && !beforePrevEnd && !beforeStart) {
        const updateValue = useMagnetic ? magneticValue : seek;
        trimPoints[index][type] = updateValue
        updateTrimPoints([...trimPoints], updateValue);
    }
    if (!isStartGrabber && beforeCurrentStart) {
        deleteTrimPoint(index)
    } else if (!isStartGrabber && afterNextStart){
        mergeTrimPoints(index, index + 1)
    } else if (!isStartGrabber && !beforeCurrentStart && !afterNextStart && !afterEnd) {
        const updateValue = useMagnetic ? magneticValue : seek;
        trimPoints[index][type] = updateValue
        updateTrimPoints([...trimPoints], updateValue);
    }
}

export function formatDuration(seconds, returnMilliseconds, includeHours) {
    if (typeof seconds === "number") {
        const hours = Math.floor(seconds / 3600);
        const minutes = includeHours
            ? Math.floor((seconds % 3600) / 60)
            : Math.floor(seconds / 60); // minuti totali se non uso ore
        const remainingSeconds = Math.floor(seconds % 60);
        const milliseconds = Math.floor((seconds - Math.floor(seconds)) * 1000);

        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(remainingSeconds).padStart(2, "0");
        const formattedMilliseconds = milliseconds.toString().padStart(3, "0");

        let result = includeHours
            ? `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
            : `${formattedMinutes}:${formattedSeconds}`;

        if (returnMilliseconds) {
            result += `.${formattedMilliseconds}`;
        }

        return result;
    }

    return seconds;
}

export function formatUTCDate(dateString, includeSeconds = true, includeTime = true) {
    if (dateString && !dateString.includes('Z')){
        dateString += 'Z';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())){
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    let ris = `${day}-${month}-${year}`;
    if (includeTime) {
        ris += ` ${hours}:${minutes}`;
    }
    if (includeSeconds) {
        ris += ':'+seconds;
    }
    return ris;
}